export const useAutoHeight = () => {
    function enter(el: HTMLElement) {
        const height = getComputedStyle(el).height

        el.style.overflow = 'hidden'
        el.style.transition = 'opacity 0.2s 0.1s ease, height 0.2s ease'
        el.style.height = '0px'
        el.style.opacity = '0'

        setTimeout(() => {
            el.style.height = height
        }, 5)
        setTimeout(() => {
            el.style.opacity = '1'
        }, 5)
    }

    function afterEnter(el: HTMLElement) {
        el.style.height = 'auto'
        el.style.opacity = '1'
    }

    function leave(el: HTMLElement) {
        const height = getComputedStyle(el).height

        el.style.overflow = 'hidden'
        el.style.transition = 'opacity 0.2s ease, height 0.2s 0.1s ease'
        el.style.height = height
        el.style.opacity = '1'

        setTimeout(() => {
            el.style.height = '0px'
            el.style.opacity = '0'
        }, 5)
    }

    return {
        afterEnter,
        enter,
        leave,
    }
}
